// @flow
import OrgsDishes from './OrgsDishes';
import { dataKey } from './dataKey';

export default OrgsDishes;
export { dataKey };
